import React from 'react'
import Text from '../../components/text/Text'
import WizButton from '../../components/button/WizButton'

interface IInfoRow {
    label: string
    value: string
}

interface IProps {
    open: boolean
    title?: string
    name?: string // 대상 이름 (강조 표시)
    rows?: IInfoRow[] // 종류 / 대상 / 상태 / 항목 수 등 부가 정보
    note?: string // 본문 안내 문구
    warning?: string // 경고 문구 (빨간 텍스트)
    confirmText?: string
    cancelText?: string
    confirmType?: 'red' | 'primary' // 확인 버튼 색상
    loading?: boolean
    onConfirm: () => void
    onCancel: () => void
}

/**
 * 삭제 등 파괴적 액션 확인용 dimmed 모달.
 * - 배경 dim 클릭 또는 취소로 닫힘 (loading 중엔 닫기 비활성)
 * - 대상 이름/종류/대상/상태 등 정보를 함께 보여 가시성 향상
 * - Volume League 페이지 전용으로 같은 폴더에 위치
 */
const ConfirmDeleteModal: React.FC<IProps> = ({
    open,
    title = '리그를 삭제할까요?',
    name,
    rows = [],
    note,
    warning,
    confirmText = '삭제',
    cancelText = '취소',
    confirmType = 'red',
    loading = false,
    onConfirm,
    onCancel,
}) => {
    if (!open) return null
    return (
        <div className="fixed inset-0 z-modal flex items-center justify-center">
            {/* dimmed 배경 */}
            <div className="absolute inset-0 bg-black/50" onClick={() => !loading && onCancel()} />
            {/* 모달 본문 */}
            <div className="relative z-10 w-[90%] max-w-[460px] bg-white rounded-[8px] p-6 shadow-hover">
                <Text className="text-h3 text-font01">{title}</Text>

                {note && <Text className="text-body2 text-font02 mt-[14px] whitespace-pre-line">{note}</Text>}
                {warning && <Text className="text-body2 text-font_red font-bold mt-[8px]">{warning}</Text>}

                <div className="mt-[24px] flex items-center justify-end gap-x-[10px]">
                    <WizButton text={cancelText} onClick={onCancel} disabled={loading} />
                    <WizButton
                        text={loading ? '처리 중…' : confirmText}
                        type={confirmType}
                        onClick={onConfirm}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default ConfirmDeleteModal
